import React from "react";
import { Route, Switch } from "react-router-dom";
import { TiepList } from "./tiep/List";
import { TiepSummary } from "./tiep/Summary";

import { Auth } from "_helpers";

const StockDelete = ({ match }) => {
  const { path } = match;

  const loggedInCustomerCode = Auth.getProfile().comp_code;

  if (loggedInCustomerCode === "TIEP") {
    return (
      <Switch>
        <Route exact path={path} component={TiepList} />
        <Route path={`${path}/:id/summary`} component={TiepSummary} />
      </Switch>
    );
  }
};

export { StockDelete };
